import checkout from "./form";

const {
  formField: { checkbox1, checkbox2, organizeName, taxId, timeSign, signer, organ1, organ2 },
} = checkout;

const initialValues = {
  [checkbox1.name]: false,
  [checkbox2.name]: false,
  [organ1.name]: "",
  [organ2.name]: "",
  [organizeName.name]: "",
  [taxId.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
